import type { FC } from "react";
import { useLocation } from "react-router";
import { NavigationSearchContainer } from "../../../features/search/navigationSearchContainer.js";
import { resourceTypeIcons } from "../resourceTypeIcons.js";
import { matchesNavPath, NavigationMenu } from "./navigationMenu.js";
import type { NavigationMenuItemProps } from "./navigationMenuItem.js";

export const AgentsNavigationMenu: FC = () => {
  const { pathname } = useLocation();

  const items: readonly NavigationMenuItemProps[] = [
    {
      label: "Agents",
      href: "/agents",
      icon: (
        <resourceTypeIcons.voiceAgent aria-hidden className="size-4 shrink-0" />
      ),
      isActive: matchesNavPath(pathname, "/agents"),
    },
    {
      label: "Tools",
      href: "/agent-tools",
      icon: <resourceTypeIcons.tool aria-hidden className="size-4 shrink-0" />,
      isActive: matchesNavPath(pathname, "/agent-tools"),
    },
  ];

  return (
    <NavigationMenu
      items={items}
      search={<NavigationSearchContainer context="team_performance" />}
    />
  );
};
